'use strict';

require('../CompanyService.js');

function CompanySettingThreeLoginCtrl(
  $scope,
  $q,
  $stateParams,
  growl,
  translations,
  reportLogins,
  CompanyService
) {

  $scope.reportLogins = reportLogins.filter(function(l) {
    return l.loginType === "GOOGLE";
  });

  $scope.loginAnalytics = function(){
    auth2.grantOfflineAccess({
      'approval_prompt': 'force',
    }).then(signInCallback);
  };

  function signInCallback(authResult) {
    if (authResult['code']) {
      var userName = '';
      var userNameDeferred = $q.defer();
      window.gapi.auth2.getAuthInstance().currentUser.listen(function(user){
        if(userName === ''){
          userName = user.w3.U3;
          userNameDeferred.resolve();
        }
      });
      
      userNameDeferred.promise.then(function(){
        CompanyService.loginAnalytic({companyId: $stateParams.companyId}, {code: authResult['code'], email: userName}, function(resp) {
          growl.addSuccessMessage(translations['settings.login-analytics-success']);
          var reportLogin = $scope.reportLogins.filter(function(item){
            return item.username === userName;
          });
          if(reportLogin[0]){
            $scope.reportLogins[$scope.reportLogins.indexOf(reportLogin[0])].accessToken = resp.accessToken;
          }else{
            $scope.reportLogins.push(resp);
          }
        }, function() {
          growl.addErrorMessage(translations['settings.login-analytics-failure']);
        });
      });
    } else {
      growl.addErrorMessage(translations['settings.login-analytics-failure']);
    }
  }

  $scope.deleteLoginAnalytic = function(login){
    CompanyService.deleteLoginAnalytic({companyId: $stateParams.companyId, loginId: login.id}, function() {
      growl.addSuccessMessage(translations['settings.delete-login-success']);
      $scope.reportLogins.splice($scope.reportLogins.indexOf(login), 1);
    }, function() {
      growl.addErrorMessage(translations['settings.delete-login-failure']);
    });
  };

  $scope.saveViewIds = function(login, isDelete){
    if(!isDelete){
      var newViewId = login.newViewId.toString();
      var isExitsLogin = $scope.reportLogins.filter(function(reportLogin){
        return reportLogin.viewIds.indexOf(newViewId) > -1;
      });
      if(!isExitsLogin[0]){
        login.viewIds.push(newViewId);
      }else{
        growl.addErrorMessage(translations['settings.this-view-id-exists']);
        return false;
      }
    }
    CompanyService.updateAnalytic({companyId: $stateParams.companyId, loginId: login.id}, login, function() {
      growl.addSuccessMessage(translations['settings.save-view-id-success']);
    }, function() {
      growl.addErrorMessage(translations['settings.save-view-id-failure']);
    });
  };
}

CompanySettingThreeLoginCtrl.resolve = {
  translations: ['$translate', function($translate) {
    return $translate([
      'settings.login-analytics-success',
      'settings.login-analytics-failure',
      'settings.delete-login-success',
      'settings.delete-login-failure',
      'settings.save-view-id-success',
      'settings.save-view-id-failure',
      'settings.this-view-id-exists'
    ]);
  }],
  reportLogins: ['CompanyService', '$stateParams', function(CompanyService, $stateParams){
    return CompanyService.getLoginAnalytics({companyId: $stateParams.companyId}).$promise;
  }]
};
module.exports = CompanySettingThreeLoginCtrl;

angular.module('dokiv')
  .controller('CompanySettingThreeLoginCtrl', [
  '$scope',
  '$q',
  '$stateParams',
  'growl',
  'translations',
  'reportLogins',
  'CompanyService',
  CompanySettingThreeLoginCtrl
]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/settings/CompanySettingThreeLoginCtrl.js
// module id = 416
// module chunks = 0